// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"41809501","165":"68ffbdfc","227":"02a8e6e8","440":"dd91b199","519":"8d78a8a5","645":"8feb4346","744":"21773ebb","893":"87a083d7","897":"69316438","925":"e0fd88a8","945":"7b88d46d"}[chunkId] + ".chunk.js";
};